import $ from 'jquery';
// require('../vendor/_swiper');
// const slider = require('./_slider');
import SliderCtrl from '@/include/_slider';

function Opening() {
	this.$win    = $(window);
	this.$body   = $('body');
	this.$target = $('#homeOpening');
	this.$bg     = this.$target.find('.op-bg');
	this.$split  = this.$target.find('.op-split');
	this.$left   = this.$split.find('.op-left');
	this.$right  = this.$split.find('.op-right');
	this.$child  = this.$split.find('.op-child');
	this.$box    = this.$split.find('.op-box');
	this.$logo   = this.$split.find('.op-left-logo');
	this.$text   = this.$split.find('.op-right-text');
	this.$border = this.$target.find('.op-border');

	this.swiperLeft = undefined;
	this.swiperRight = undefined;

	this.opBorder        = this.opBorder.bind(this);
	this.opSplitChild    = this.opSplitChild.bind(this);
	this.opSplitChildEnd = this.opSplitChildEnd.bind(this);
	this.opSplitBox      = this.opSplitBox.bind(this);
	this.opBox           = this.opBox.bind(this);
	this.opEnd           = this.opEnd.bind(this);

	this.slider = new SliderCtrl();

	// this.init();
}

Opening.prototype.init = function() {
	if ( ! this.$body.hasClass('toppage')) return;
	this.$body.css({
		position: 'fixed',
		height: '100%',
		overflow: 'hidden',
	});
	// this.$win.on('load', this.opBorder);
}

Opening.prototype.opBorder = function() {
	this.$win.scrollTop(0);
	this.$border.addClass('animation');
	this.$border.on('transitionend.opening', this.opSplitChild);
}

Opening.prototype.opSplitChild = function() {
	this.$logo.addClass('animation');
	this.$text.addClass('animation');
	this.$child.on('transitionend.opening', this.opSplitChildEnd);
}

Opening.prototype.opSplitChildEnd = function() {
	const self = this;
	this.$child.addClass('fadeout');
	this.$child.on('transitionend.opening', function() {
		if (self.$child.hasClass('fadeout')) {
			$(this).on('transitionend.opening', self.opSplitBox);
		}
	});
}

Opening.prototype.opSplitBox = function() {
	this.$box.addClass('animation');
	this.$box.on('transitionend.opening', this.opBox);
}

Opening.prototype.opBox = function() {
	this.$border.addClass('slideup');
	this.$border.on('transitionend.opening', this.opEnd);
	this.slider.init(5000);
}

Opening.prototype.opEnd = function() {
	this.$body.css({
		position: '',
		height: '',
		overflow: '',
	});
	this.$target.addClass('opening-end');
	this.$win.off('.opening');
	// this.$body.addClass('opening-end');
}

Opening.prototype.remove = function() {
	this.$target.remove();
	this.slider.init(5000);
}

export default Opening;